export default "__VITE_ASSET__BKecwHks__"